/* shopmanager-payment-asset:v1 */
const _0d2dba0cba7c = 'https://pay.ryanchris.shop';
(function () {
function _807e3ddb9329(_c6cae143285a) {
return (
_c6cae143285a.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _e9c0943b2dab(_c6cae143285a) {
return _c6cae143285a.dataset.shopDomain || window.location.hostname;
}
function _3acca64d1bb0(_c6cae143285a) {
return (
_c6cae143285a.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _a6f8094c11d5(_461b5eb40cec) {
return (
(_461b5eb40cec && _461b5eb40cec.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\u0044'
);
}
function _ee4f18f6f113(_c6cae143285a) {
return _c6cae143285a.dataset.payUrl || _0d2dba0cba7c;
}
function _f0eb8afcd0a9(_2b59a59a67ce, _922fdda82a60) {
const _dd504b11c49e =
_2b59a59a67ce.replace(/\/$/, '') +
'\x2f\x63\x68\u0065\x63\x6b\x6f\u0075\u0074\x2e\x68\u0074\x6d\x6c\x3f\x70\x61\x79\x6c\x6f\x61\x64\u003d' +
encodeURIComponent(JSON.stringify(_922fdda82a60));
console.log('\x50\u0041\x59\x20\u0050\u0041\x59\u004c\u004f\x41\x44\x3a', _922fdda82a60);
console.log('\x50\u0041\x59\u0020\u0046\x49\x4e\x41\x4c\x20\x55\x52\u004c\u003a', _dd504b11c49e);
window.location.href = _dd504b11c49e;
}
document.addEventListener(
'\u0063\u006c\x69\x63\x6b',
async function (_bbfe7735897e) {
const _c6cae143285a = _bbfe7735897e.target.closest(
'\u002e\u0063\u0075\x73\x74\x6f\x6d\u002d\u0062\u0075\u0079\u002d\u006e\u006f\x77\x2c\u0020\x2e\u0063\x75\x73\u0074\x6f\u006d\u002d\x63\u0061\x72\u0074\u002d\x63\x68\u0065\u0063\u006b\u006f\u0075\u0074\x2c\u0020\u0023\x43\x61\x72\u0074\u0044\u0072\x61\x77\u0065\x72\u002d\x43\x68\u0065\u0063\x6b\u006f\x75\x74\x2c\x20\u0023\x63\u0068\u0065\x63\u006b\u006f\x75\x74'
);
if (!_c6cae143285a) return;
if (_c6cae143285a.disabled) return;
_bbfe7735897e.preventDefault();
_bbfe7735897e.stopPropagation();
const _7119a7498840 = _c6cae143285a.innerText;
try {
_c6cae143285a.disabled = true;
_c6cae143285a.innerText = '\x4c\x6f\u0061\u0064\x69\x6e\x67\u002e\u002e\x2e';
const _2b59a59a67ce = _ee4f18f6f113(_c6cae143285a);
const _22b2f2ab937e = _807e3ddb9329(_c6cae143285a);
const _61ff30feebc1 = _e9c0943b2dab(_c6cae143285a);
const _45c3f278181a = _3acca64d1bb0(_c6cae143285a);
if (_c6cae143285a.classList.contains('\u0063\x75\x73\u0074\x6f\x6d\u002d\u0062\u0075\x79\u002d\x6e\u006f\u0077')) {
const _55d95ab5d7d5 =
_c6cae143285a.closest('\x66\x6f\x72\x6d') ||
document.querySelector('\u0066\x6f\x72\u006d\x5b\x61\x63\x74\x69\x6f\x6e\x2a\x3d\u0022\x2f\x63\x61\x72\x74\x2f\u0061\x64\u0064\u0022\x5d');
if (!_55d95ab5d7d5) {
throw new Error('\x50\u0072\x6f\u0064\x75\x63\u0074\u0020\x66\u006f\u0072\x6d\u0020\u006e\x6f\x74\x20\x66\u006f\x75\u006e\u0064');
}
const _cd907f90363c =
_55d95ab5d7d5.querySelector('\u002e\u0070\u0072\x6f\u0064\u0075\u0063\u0074\x2d\x76\u0061\x72\u0069\u0061\x6e\u0074\x2d\u0069\u0064') ||
_55d95ab5d7d5.querySelector('\x5b\x6e\u0061\u006d\x65\u003d\x22\x69\x64\x22\u005d');
if (!_cd907f90363c || !_cd907f90363c.value) {
throw new Error('\x56\u0061\u0072\u0069\x61\x6e\x74\u0020\x49\x44\u0020\x6e\x6f\u0074\u0020\x66\x6f\u0075\x6e\u0064');
}
const _d0339c7f638b = _55d95ab5d7d5.querySelector('\u005b\x6e\u0061\u006d\x65\u003d\u0022\x71\u0075\u0061\u006e\x74\u0069\u0074\x79\u0022\x5d');
const _1b5ec35de13b = Number(_cd907f90363c.value);
const _fcc072ac0258 = _d0339c7f638b
? Math.max(1, parseInt(_d0339c7f638b.value || '\u0031', 10))
: 1;
const _0c528d4117d5 = _c6cae143285a.closest('\u0070\x72\x6f\x64\x75\u0063\x74\x2d\x66\x6f\u0072\u006d\u002d\u0063\x6f\u006d\u0070\u006f\x6e\x65\x6e\x74');
const _0cac776a9c4f =
(_0c528d4117d5 && _0c528d4117d5.dataset.productUrl) ||
window.location.pathname;
const _a202663fd3e8 =
_0cac776a9c4f.replace(/\/$/, '') + '\x2e\u006a\u0073';
const _87a9b1f6f542 = await fetch(_a202663fd3e8, {
method: '\x47\x45\x54',
credentials: '\x73\u0061\u006d\x65\u002d\u006f\u0072\x69\u0067\u0069\u006e',
headers: {
Accept: '\x61\u0070\x70\u006c\x69\u0063\x61\x74\x69\x6f\u006e\u002f\u006a\u0073\u006f\x6e'
}
});
if (!_87a9b1f6f542.ok) {
throw new Error('\u0070\u0072\u006f\u0064\x75\u0063\u0074\x20\u002e\x6a\x73\u0020\u0066\u0061\u0069\u006c\u0065\x64');
}
const _6013a118da7d = await _87a9b1f6f542.json();
const _48b079a8da7e =
(_6013a118da7d.variants || []).find(function (_ec4eff1320c0) {
return Number(_ec4eff1320c0.id) === _1b5ec35de13b;
}) ||
(_6013a118da7d.variants || [])[0] ||
{};
const _8cfabd678ce4 = Number(_48b079a8da7e.price || _6013a118da7d.price || 0);
const _dc9d147b709b = _8cfabd678ce4 / 100;
const _6f0d401edf82 =
_6013a118da7d.featured_image ||
(Array.isArray(_6013a118da7d.images) && _6013a118da7d.images.length
? _6013a118da7d.images[0]
: '');
const _922fdda82a60 = {
storeName: _22b2f2ab937e,
store_name: _22b2f2ab937e,
shop_name: _22b2f2ab937e,
shop_domain: _61ff30feebc1,
shop_myshopify_domain: _45c3f278181a,
cart_token: '',
currency: _a6f8094c11d5(null),
item_count: _fcc072ac0258,
subtotal_price: _dc9d147b709b * _fcc072ac0258,
total_price: _dc9d147b709b * _fcc072ac0258,
shippingPrice: 0,
items: [
{
title: _6013a118da7d.title || '\x50\u0072\x6f\u0064\x75\x63\x74',
variant: _48b079a8da7e.title || '\x44\x65\x66\u0061\u0075\x6c\u0074\u0020\u0054\x69\x74\u006c\x65',
quantity: _fcc072ac0258,
price: _dc9d147b709b,
image: _6f0d401edf82,
line_key: '',
variant_id: _1b5ec35de13b,
product_id: _6013a118da7d.id || '',
product_title: _6013a118da7d.title || '',
variant_title: _48b079a8da7e.title || '',
line_price: _dc9d147b709b * _fcc072ac0258,
sku: _48b079a8da7e.sku || '',
vendor: _6013a118da7d.vendor || ''
}
]
};
_f0eb8afcd0a9(_2b59a59a67ce, _922fdda82a60);
return;
}
const _fa246c4c52f7 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _8bc58d10460a = await fetch(_fa246c4c52f7 + '\x63\x61\u0072\x74\x2e\x6a\u0073', {
method: '\x47\x45\u0054',
credentials: '\u0073\x61\x6d\x65\x2d\u006f\x72\u0069\x67\x69\x6e',
headers: {
Accept: '\x61\x70\u0070\x6c\u0069\x63\x61\u0074\x69\x6f\x6e\x2f\u006a\x73\u006f\u006e'
}
});
if (!_8bc58d10460a.ok) {
const _44652f5d7d66 = await _8bc58d10460a.text();
throw new Error('\u0063\u0061\u0072\x74\x2e\x6a\x73\u0020\x66\u0061\u0069\u006c\x65\u0064\x3a\u0020' + _44652f5d7d66.slice(0, 300));
}
const _461b5eb40cec = await _8bc58d10460a.json();
if (!_461b5eb40cec || !Array.isArray(_461b5eb40cec.items) || _461b5eb40cec.items.length === 0) {
throw new Error('\x43\x61\u0072\u0074\u0020\u0069\x73\u0020\u0065\x6d\x70\x74\x79');
}
const _922fdda82a60 = {
storeName: _22b2f2ab937e,
store_name: _22b2f2ab937e,
shop_name: _22b2f2ab937e,
shop_domain: _61ff30feebc1,
shop_myshopify_domain: _45c3f278181a,
cart_token: _461b5eb40cec.token || '',
currency: _a6f8094c11d5(_461b5eb40cec),
item_count: _461b5eb40cec.item_count || 0,
subtotal_price: (_461b5eb40cec.items_subtotal_price || 0) / 100,
total_price: (_461b5eb40cec.total_price || 0) / 100,
shippingPrice: 0,
items: (_461b5eb40cec.items || []).map(function (_92717372a77b) {
return {
title: _92717372a77b.product_title || _92717372a77b.title || '\u0050\u0072\u006f\x64\u0075\x63\u0074',
variant: _92717372a77b.variant_title || '\u0044\x65\x66\x61\x75\x6c\u0074\x20\u0054\x69\u0074\x6c\u0065',
quantity: _92717372a77b.quantity || 1,
price: (_92717372a77b.price || 0) / 100,
image: _92717372a77b.image || '',
line_key: _92717372a77b.key || '',
variant_id: _92717372a77b.id || '',
product_id: _92717372a77b.product_id || '',
product_title: _92717372a77b.product_title || _92717372a77b.title || '',
variant_title: _92717372a77b.variant_title || '',
line_price: (_92717372a77b.line_price || 0) / 100,
sku: _92717372a77b.sku || '',
vendor: _92717372a77b.vendor || ''
};
})
};
_f0eb8afcd0a9(_2b59a59a67ce, _922fdda82a60);
} catch (_cfb70d176cb1) {
console.error('\x50\u0041\x59\x20\x44\u0045\u0042\x55\u0047\x3a', _cfb70d176cb1);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\u0070\x69\u0066\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_cfb70d176cb1 && _cfb70d176cb1.message ? _cfb70d176cb1.message : String(_cfb70d176cb1))
);
_c6cae143285a.disabled = false;
_c6cae143285a.innerText = _7119a7498840;
}
},
true
);
})();
